<template>
  <div class="my-2">
    <h4>Task Loading List</h4>
    <table width="100%" border="0" v-if="task">
      <tr :class="{'task-loading-summary-row': true, 'summary-row-cancelled': isTaskItemCancelled(taskItem)}" v-for="(taskItem, taskItemIndex) of task.taskItems" :key="taskItem.id">
        <td class="tasks-item-row-index-marker" width="5%">
          {{taskItemIndex+1}}
        </td>
        <td class="task-item-title" width="45%">
          <strong>{{taskItem.name}}</strong><span v-if="taskItem.isLocationEnabled"> - {{taskItem.locationAddress}}</span>
        </td>
        <td width="40%" class="task-loading-summary-progress">
          <div v-if="taskItemRequiresLoading(taskItem)">
            <ProgressBar :percent="(taskItemTotalScannedInQty(taskItem, taskItemScannedItemList) / taskItemTotalRequiredQty(taskItem)) * 100.0" />
          </div>
        </td>
        <td width="10%" class="text-left font-weight-bold text-muted pl-4">
          <div v-if="taskItemRequiresLoading(taskItem)">
            {{taskItemTotalScannedInQty(taskItem, taskItemScannedItemList)}} / {{taskItemTotalRequiredQty(taskItem)}}
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<style lang="scss" scoped>
.task-loading-summary-row {
  font-size: 13px;
  height: 50px;
}
.task-loading-summary-row > td {
  height: 50px;
  line-height: 50px;
  vertical-align: middle;
}
.task-loading-summary-row.summary-row-cancelled .task-item-title {
  text-decoration: line-through !important;
  color: $label-status-cancelled !important;
}
.task-loading-summary-progress {
  padding-top: 10px;
}
.task-item-title {
  color: #676a6c;
  vertical-align: middle;
}
</style>

<script>
import ProgressBar from '@/components/progressBar'
import TaskDespatchMixin from '@/modules/tasks/mixins/taskDespatchMixin'

import { TaskItemTypes, TaskItemStatusTypes } from '@/store/types'

export default {
  name: 'TaskLoadingSummary',
  mixins: [TaskDespatchMixin],
  components: {
    ProgressBar
  },
  props: {
    task: Object,
    taskItemScannedItemList: Array
  },
  methods: {
    
    isTaskItemCancelled(taskItem) {
      return taskItem.status == TaskItemStatusTypes.cancelled
    },
  }
}
</script>